import styled from 'styled-components';

const Svg = styled.svg`
  ${({ theme: { spacing } }) => `
    width: ${spacing(5)};
    height: ${spacing(5)};
  `}
`;

type Props = {
  color?: string;
  className?: string;
};

const QuestionMarkCircle = ({ className = '', color = 'white' }: Props) => (
  <Svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill={color}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 21.6C6.706 21.6 2.4 17.295 2.4 12C2.4 6.707 6.706 2.4 12 2.4C17.293 2.4 21.6 6.707 21.6 12C21.6 17.295 17.293 21.6 12 21.6ZM12 0C5.373 0 0 5.373 0 12C0 18.628 5.373 24 12 24C18.626 24 24 18.628 24 12C24 5.373 18.626 0 12 0ZM11.1463 18.5023H13.4244V16.2434H11.1463V18.5023ZM12.1579 5.27234C11.1908 5.28499 10.3488 5.63467 9.65686 6.30872C8.94907 6.98007 8.58353 7.84839 8.57234 8.892V9.47389H10.8486V9.248C10.8486 8.60286 10.9922 8.14927 11.2841 7.89266C11.5359 7.64961 11.8539 7.53124 12.2558 7.53124C12.5766 7.53124 12.8666 7.64689 13.1379 7.87911C13.4056 8.12307 13.5408 8.45558 13.5511 8.8911C13.5511 9.21005 13.4205 9.56425 13.1631 9.94103L11.6291 12.1548C11.4361 12.4376 11.3037 12.7267 11.2347 13.0195C11.1759 13.3077 11.147 13.6321 11.147 13.9872V15.3778H13.4252V14.129C13.4149 13.736 13.4998 13.4017 13.6779 13.1378L15.2333 10.9096C15.6156 10.3756 15.8161 9.7034 15.8283 8.90555C15.8152 7.79327 15.4375 6.89423 14.7027 6.23463C13.9977 5.60846 13.1445 5.28499 12.1579 5.27234Z"
    />
  </Svg>
);

export default QuestionMarkCircle;
